"use client";

import { BellRing, Cctv, HouseWifi, KeyRound, Wifi } from "lucide-react";
import Carousel, { CarouselSlide } from "../carousel/Carousel";

const slides: CarouselSlide[] = [
  {
    title: "Monitoring Wideo",
    description:
      "Zapraszamy do zapoznania się z naszą ofertą profesjonalnych systemów monitoringu wideo. Jako doświadczona firma elektroinstalacyjna specjalizujemy się w nowoczesnych i niezawodnych rozwiązaniach dla klientów indywidualnych oraz biznesowych.",
    Icon: Cctv,
  },
  {
    title: "Smart Home",
    description:
      "Systemy inteligentnego domu, znane jako Smart Home, to przyszłość zarządzania przestrzenią mieszkalną. Umożliwiają integrację różnego rodzaju instalacji i urządzeń w jeden, spójny ekosystem, który zwiększa komfort, bezpieczeństwo i efektywność codziennego życia.",
    Icon: HouseWifi,
  },
  {
    title: "Kontrola Dostępu",
    description:
      "Nowoczesne systemy kontroli dostępu dla Twojej firmy — bo bezpieczeństwo to fundament sukcesu każdej organizacji.",
    Icon: KeyRound,
  },
  {
    title: "Systemy Alarmowe",
    description:
      "Profesjonalny montaż systemów alarmowych dla domu i firmy. Oferujemy nowoczesne rozwiązania, które gwarantują najwyższy poziom bezpieczeństwa. Nasi eksperci dopasują system do Twoich potrzeb. Skontaktuj się z nami już dziś!",
    Icon: BellRing,
  },
  {
    title: "Sieci LAN i WI-FI",
    description:
      "Oferujemy montaż sieci LAN i Wi-Fi dla domów i firm. Zapewniamy profesjonalną instalację oraz konfigurację, gwarantując niezawodność i wydajność sieci. Skontaktuj się z nami, aby poznać szczegóły.",
    Icon: Wifi,
  },
];

const ServicesCarousel = () => {
  return <Carousel slides={slides} autoplay />;
};

export default ServicesCarousel;
